import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/Sushi-Sama-2022937594647159">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Sama Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/sushi-sama-maple-ridge">
              <CFImage w="40px" pr="10px" src={yelp} alt="Sushi Sama Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/sushi-sama-maple-ridge">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sushi Sama Zomato"
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/yohachi_sushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi Sama Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/Sushi-Sama-2022937594647159">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Sama Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/sushi-sama-maple-ridge">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Sushi Sama Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/sushi-sama-maple-ridge">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sushi Sama Zomato"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/yohachi_sushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi Sama Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
